import { render, staticRenderFns } from "./standardNewsForm.vue?vue&type=template&id=74d5fa80&"
import script from "./standardNewsForm.vue?vue&type=script&lang=js&"
export * from "./standardNewsForm.vue?vue&type=script&lang=js&"
import style0 from "./standardNewsForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "standardNewsForm.vue"
export default component.exports